import Vue from 'vue'
import Vuex from 'vuex'
import games from './modules/games'
import game from './modules/game'
import alert from './modules/alert';
import account from './modules/account';
import users from './modules/user';
// import createLogger from '../../../src/plugins/logger'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    games,
    game,
    alert,
    account,
    users
  },
  strict: debug,
  plugins: debug ? [/*createLogger()*/] : []
})
